import { Reducer } from 'redux';
import { DetalhesOrdemCargaTypes, DetalhesOrdemCargaState } from './types';

const INITIAL_STATE: DetalhesOrdemCargaState = {
  data: undefined,
  error: false,
  loading: false,
};

const reducer: Reducer<DetalhesOrdemCargaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DetalhesOrdemCargaTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DetalhesOrdemCargaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case DetalhesOrdemCargaTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: undefined,
      };
    case DetalhesOrdemCargaTypes.CLEAR_DETALHES_ORDEMCARGA:
      return {
        ...state,
        loading: false,
        error: false,
        data: undefined,
      };

    default:
      return state;
  }
};

export default reducer;
